YP.EventStoreTag = function() {
    var tagSelected = [];

    return {
        init: function() {
            YP.ModalManager().setPreCallSuccess(this.initStoreTagForm);
            YP.ModalManager().setPostCallSuccess(this.updateStoreForm);
            YP.EventStoreTag().deleteStoreTag();

        },
        initStoreTagForm: function() {
            $(".spectrum.background").spectrum({
                preferredFormat: "hex",
                clickoutFiresChange: true,
                showInitial: true,
                showInput: true,
                chooseText: "Choisir",
                cancelText: "Annuler",
                showPalette: true,
                showSelectionPalette: true,
                palette: [],
                localStorageKey: "yurplan.tag-store.spectrum",
                appendTo: '#main-modal',
                move: function(color) {
                    $('.preview-store-tag').css('background-color', color.toHexString());
                },
                change: function(color) {
                    $('.preview-store-tag').css('background-color', color.toHexString());
                }
            });
            $(".spectrum.text").spectrum({
                preferredFormat: "hex",
                clickoutFiresChange: true,
                showInitial: true,
                showInput: true,
                chooseText: "Choisir",
                cancelText: "Annuler",
                showPalette: true,
                showSelectionPalette: true,
                palette: [],
                localStorageKey: "yurplan.tag-store.spectrum",
                appendTo: '#main-modal',
                move: function(color) {
                    $('.preview-store-tag').css('color', color.toHexString());
                },
                change: function(color) {
                    $('.preview-store-tag').css('color', color.toHexString());
                }
            });
            $("#store_tag_label").on('change', function() {
                $('.preview-store-tag').html($(this).val());
            });
            $("#store_tag_label").each(function() {
                var elem = $(this);

                // Save current value of element
                elem.data('oldVal', elem.val());
                // Look for changes in the value
                elem.bind("propertychange change click keyup input paste", function(event) {
                    // If value has changed...
                    if (elem.data('oldVal') != elem.val()) {
                        // Updated stored value
                        elem.data('oldVal', elem.val());

                        $('.preview-store-tag').html($(this).val());

                    }
                });
            });

        },
        deleteStoreTag: function() {
            $('.js-delete-cat').on('click', function(e){
                e.preventDefault();
                url = $(this).data('url');
                catRow = $(this).parent('.p-event-atelier__cat_row');
                if(confirm('Êtes-vous sûre de vouloir supprimer cette catégorie?')){
                    catRow.remove();
                    $.ajax({
                        url: url,
                        dataType: 'json',
                        success: function(data) {
                            YP.EventStoreTag().updateStoreForm();
                        }
                    });
                }
            });
        },
        updateStoreForm: function(data) {
            $storeTagContainer = $('.store-tag-field-container');
            this.tagSelected = [data.id];
            var klass = this;

            $storeTagContainer.find('input:checked').each(function() {
                klass.tagSelected.push(this.value);
            });

            $updateFormUrl = $storeTagContainer.data('url');
            $.ajax({
                url: $updateFormUrl,
                dataType: 'json',
                success: function(data) {
                    if (data) {
                        $storeTagContainer.html(data.view);
                        $storeTagContainer.find('input[value="' + klass.tagSelected.join('"],[value="') + '"]').prop('checked', true);
                        $storeTagContainer.find('input').prop({
                            checkboxClass: 'c-form-input',
                            radioClass: 'c-form-input',
                            area: '10%',
                            tap: true,
                        });
                        YP.EventStoreTag().deleteStoreTag();
                    }
                }
            });
        }
    };
};

window.addEventListener("load", function() {
    if ($('.workshop-tag-liste').length) {
        YP.EventStoreTag().init();
    }
});
